import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
    { path: '/dashboard', title: 'Dashboard', icon: 'material-icons' }, // 0

    { path: '/pages/timeline', title: 'Timeline Page', icon:'material-icons' }, // 1
    { path: '/pages/user', title: 'User Page', icon:'material-icons' }, // 2

    { path: '/components/buttons', title: 'Buttons', icon:'pe-7s-plugin' }, // 3
    { path: '/components/grid', title: 'Grid System', icon:'pe-7s-plugin' }, // 4
    { path: '/components/panels', title: 'Panels', icon:'pe-7s-plugin' }, // 5
    { path: '/components/sweet-alert', title: 'Sweet Alert', icon:'pe-7s-plugin' }, // 6
    { path: '/components/notifications', title: 'Notifications', icon:'pe-7s-plugin' }, // 7
    { path: '/components/icons', title: 'Icons', icon:'pe-7s-plugin' }, // 8
    { path: '/components/typography', title: 'Typography', icon:'pe-7s-plugin' }, // 9

    { path: '/forms/regular', title: 'Regular Forms', icon:'pe-7s-note2' }, // 10
    { path: '/forms/extended', title: 'Extended Forms', icon:'pe-7s-note2' }, // 11
    { path: '/forms/validation', title: 'Validation Forms', icon:'pe-7s-note2' }, // 12
    { path: '/forms/wizard', title: 'Wizard', icon:'pe-7s-note2' }, // 13

    { path: '/tables/regular', title: 'Regular Tables', icon:'pe-7s-news-paper' }, // 14
    { path: '/tables/extended', title: 'Extended Tables', icon:'pe-7s-news-paper' }, // 15
    { path: '/tables/datatables.net', title: 'DataTables.net', icon:'pe-7s-news-paper' }, // 16

    { path: '/maps/google', title: 'Google Maps', icon:'pe-7s-map-marker' }, // 17
    { path: '/maps/fullscreen', title: 'Full Screen Map', icon:'pe-7s-map-marker' }, // 18
    { path: '/maps/vector', title: 'Vector Map', icon:'pe-7s-map-marker' }, // 19

    { path: '/widgets', title: 'Widgets', icon:'material-icons' }, // 20

    { path: '/charts', title: 'Charts', icon:'material-icons' }, // 21

    { path: '/calendar', title: 'Calendar', icon:'material-icons' }, // 22

    { path: '/pages/pricing', title: 'Pricing', icon:'material-icons' }, // 23
    { path: '/pages/login', title: 'Login Page', icon:'material-icons' }, // 24
    { path: '/pages/register', title: 'Register Page', icon:'material-icons' }, // 25
    { path: '/pages/lock', title: 'Lock Screen Page', icon:'material-icons' }, // 26

    { path: '/cadastros', title: 'Cadastros', icon:'material-icons' }, // 27
    

];



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar-routes.config.ts